import React from "react";

const ErrorPage = () => {
  return (
    <div className="text-center mt-10">
      <h1 className="text-4xl font-bold">Oops! 😵</h1>
      <h2 className="text-2xl mt-4">Page not found!</h2>
    </div>
  );
};

export default ErrorPage;
